import { useLang } from "@/i18n";

export const Logo = () => {
  const { t } = useLang();
  return (
    <span className="flex items-center gap-3" data-testid="navbar-brand-logo">
      <img
        src="/assets/cc-logo.png"
        alt="شعار مركز كونكتد"
        className="h-11 w-11 rounded-full object-cover ring-1 ring-[#E3AF4F]/40"
      />
      <span className="flex flex-col leading-none">
        <span className="font-heading text-[11px] font-bold tracking-[0.22em] text-[#F5F2EB]">
          {t.brand.name}
        </span>
        <span className="mt-1 text-[11px] text-[#E3AF4F]">{t.brand.sub}</span>
      </span>
    </span>
  );
};
